import React, { FC } from 'react';
import intl from 'components/i18n/ReactIntlWrapper';
import { Select as Selec, MenuItem, FormControl, InputLabel } from '@mui/material';

type InvoicesStatusSelectProps = {
  invoiceStatus: any,
  selectedStatus: any,
  handleStatusChange: any
};

const InvoicesStatusSelect: FC<InvoicesStatusSelectProps> = ({ invoiceStatus, selectedStatus, handleStatusChange }) => {
  return (
    <>
    <FormControl>
      <InputLabel
        id="invoice-status-label"
        sx={{
          color: 'text.secondary',
          marginTop: -1,
          '&.Mui-focused': {
            color: 'primary.main'
          }
        }}
      >
        {intl.get('invoicesStatusSelect.status')}
      </InputLabel>
      <Selec
        sx={{
          height: 43,
          width: 200,
        }}
        labelId="invoice-status-label"
        id="invoiceStatus"
        value={selectedStatus}
        onChange={handleStatusChange}
        label={intl.get('invoicesStatusSelect.status')}
      > 
         <MenuItem value={null}>
            <em>Status</em>
          </MenuItem>
        {invoiceStatus && invoiceStatus.map((status, index) => (
          <MenuItem key={index} value={status.id}>
            {intl.get(status.labelKey)}
          </MenuItem>
        ))}
      </Selec>
    </FormControl>
    </>
  );
}

export default InvoicesStatusSelect;
